module.exports = __webpack_public_path__ + "img/case1.c390d804.png";